import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './physicalCards.module.scss';
import { actions } from '../../state';
import { formatMoney, formatMoneyToCents } from '../../utils';
import { Button, Input, TitleSecondary } from '../../components';

const ACTIVE_STATUS = 1;

const TopUp = ({
  dispatch,
  cardId,
  currentBalance,
  cardStatus,
  loading,
  formSyncAt,
}) => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => {
    setAmount('');
    setNote('');
  }, [formSyncAt]);

  const isActive = Number(cardStatus) === ACTIVE_STATUS;
  const amountValue = Number(amount);
  const canSubmit =
    isActive &&
    amount !== '' &&
    !Number.isNaN(amountValue) &&
    amountValue > 0 &&
    note.trim().length > 0;

  const handleAmountChange = ({ target: { value } }) => {
    setAmount(value);
  };

  const handleNoteChange = ({ target: { value } }) => {
    setNote(value);
  };

  const openTopUpModal = () => {
    if (!canSubmit) return;

    const amountCents = formatMoneyToCents(amount);
    const trimmedNote = note.trim();

    const payload = {
      modalName: 'confirmModal',
      title: 'Papildyti kortelę',
      desc: 'Ar tikrai norite papildyti kortelę nurodyta suma?',
      onConfirm: () => {
        // Uncertain: currently calls POST /h2_cards/:id/top_up — may need a different endpoint later.
        dispatch(
          actions.physicalCards.topUpPhysicalCardAction(cardId, {
            amount: amountCents,
            note: trimmedNote,
          })
        );
        setAmount('');
        setNote('');
      },
    };

    dispatch(actions.modals.clearModals());
    dispatch(actions.modals.setModalVisible(payload));
  };

  return (
    <div className={styles.topUpSection}>
      <TitleSecondary>Papildymas</TitleSecondary>

      <div className={styles.topUpBalanceRow}>
        <span className={styles.topUpBalanceLabel}>Dabartinis likutis</span>
        <span className={styles.topUpBalanceValue}>
          {formatMoney(currentBalance || 0)}
        </span>
      </div>

      {!isActive && (
        <p className={styles.topUpHint}>Papildyti galima tik aktyvią kortelę</p>
      )}

      <div className={styles.topUpFields}>
        <Input
          name="topUpAmount"
          type="number"
          min="0.01"
          step="0.01"
          placeholder="0.00"
          label="Suma (€)"
          value={amount}
          onChange={handleAmountChange}
          disabled={!isActive || loading}
        />
        <Input
          name="topUpNote"
          type="text"
          label="Priežastis"
          value={note}
          onChange={handleNoteChange}
          disabled={!isActive || loading}
          required
        />
        <Button
          color={canSubmit ? 'primary' : 'outline'}
          disabled={!canSubmit || loading}
          onClick={openTopUpModal}
        >
          Papildyti
        </Button>
      </div>
    </div>
  );
};

TopUp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentBalance: PropTypes.number,
  cardStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
  formSyncAt: PropTypes.number,
};

TopUp.defaultProps = {
  currentBalance: 0,
  cardStatus: null,
  loading: false,
  formSyncAt: null,
};

export default connect()(TopUp);
